import React, { Component } from 'react';
import { connect } from 'react-redux';
import CLIENT from '../../../utils/restClient';
import BusySpinner from '../../spinners/BusySpinner'
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import FileSaveAs from  '../../downloaders/FileSaveAs';

const log = new Logger('FIXEDFORMAT_URI_VIEWER', LOG_LEVELS.DEBUG);
export class FixedFormatUriViewer extends Component {
  
  constructor(props) {
    super(props);
    this.fetchDocument = this.fetchDocument.bind(this);
    this.fetchBlob = this.fetchBlob.bind(this);
  }

  render() {
    log.debug('render(): ', this.props);
    const filename = this.props.filename || (() => {
      const split = this.props.uri.split('/');
      return split[split.length -1];
    })();
    const fullName = `${filename}.${this.props.fileExtension}`;

    const hasData = this.state.data != null && this.state.data !== '';
    const isLoaded = this.state.loaded;
    const hasError = !!this.state.error;

    return (
      <div>
        <BusySpinner busy={this.state.loading} />
        {hasData && (
          <fieldset>
            <textarea rows="10" defaultValue={this.state.data}></textarea><br />
            {!this.props.hideDownload && (
              <FileSaveAs
                fetchContent={this.fetchBlob}
                downloadLabel={`${LANGUAGES_CONTROLLER.format(this.props.languages, 'fixedFormat_download')} ${fullName}`}
                filename={filename}
                isBlob={true}
              />
            )}
          </fieldset>
        )}
        {!hasData && isLoaded && hasError && (
          <div data-test="component-fixed-format-uri-viewer-error">
            <span><LanguageStringResolver string='fixedFormat_error'/> {fullName}</span>
          </div>
        )}
        {!hasData && isLoaded && !hasError && (
          <div data-test="component-fixed-format-uri-viewer-empty">
            <span><LanguageStringResolver string='fixedFormat_empty'/> {fullName}</span>
          </div>
        )}
        {!hasData && !isLoaded && (
          <div data-test="component-fixed-format-uri-viewer-loading">
            <span><LanguageStringResolver string='fixedFormat_loading'/> {fullName}</span>
          </div>
        )}
      </div>
    );
  }

  fetchDocument() {
    CLIENT.getFilingDocumentAsText('TXT', this.props.uri)
      .then((response) => {
        log.debug('fetchDocument(): getFilingDocumentAsText got a response: ' + response);
        this.setState({
          loading: false,
          loaded: true,
          data: response,
          error: undefined
        })
      })
      .catch((error) => {
        log.warn('fetchDocument(): getFilingDocumentAsText got an error: ', error);
        this.setState({
          loading: false,
          loaded: true,
          data: undefined,
          error: error
        })
      });
      this.setState({
      loading: true,
      loaded: false,
      data: undefined,
      error: undefined
    });
  }
    
  fetchBlob() {
    log.debug('onDownloadFilingDocument()');
    return new Promise((resolve, reject) => {
      CLIENT.getFilingDocumentAsBlob('Blob', this.props.uri).then((data) => {
        const downloadData = {
          content: data || '', ext: this.props.fileExtension
        };
        resolve(downloadData);
      }).catch((err) =>{
        reject(err);
        return;
      })
    });
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.fetchDocument();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    log.debug('componentDidUpdate()');
    if(this.props.uri !== prevProps.uri) {
      this.fetchDocument();
    }
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


FixedFormatUriViewer.defaultProps = {
  hideDownload: false
};

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FixedFormatUriViewer);